export default "__VITE_ASSET__qNOjREPW__"